import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { FormikSwitch } from '../../../../components/Formik';

interface NetworkConnectivityProps {
  externalNetworks: string[];
}

const NetworkConnectivity = ({ externalNetworks }: NetworkConnectivityProps): React.JSX.Element => {
  const intl = useIntl();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={8}
      >
        <Typography>
          <strong>{intl.formatMessage({ id: 'internetConnectivity' })}: </strong>
          {intl.formatMessage({ id: 'internetConnectivityDescription' })}
          <br />
          {intl.formatMessage({ id: 'internetConnectivityDisabledDescription' })}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <FormikSwitch
          name='internetConnectivity'
          label={intl.formatMessage({ id: 'internetConnectivity' })}
          disabled={!externalNetworks.includes('external_internet_provider')}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <Typography>
          <strong>{intl.formatMessage({ id: 'dthConnectivity' })}: </strong>
          {intl.formatMessage({ id: 'dthConnectivityDescription' })}
          <br />
          {intl.formatMessage({ id: 'dthConnectivityDisabledDescription' })}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <FormikSwitch
          name='DTHConnectivity'
          label={intl.formatMessage({ id: 'dthConnectivity' })}
          disabled={!externalNetworks.includes('external_pi-net_provider')}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
      >
        <Typography>
          <strong>{intl.formatMessage({ id: 'dthRedRouterConnectivity' })}: </strong>
          {intl.formatMessage({ id: 'dthRedRouterConnectivityDescription' })}
          <br />
          {intl.formatMessage({ id: 'dthRedRouterConnectivityDisabledDescription' })}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <FormikSwitch
          name='DTHRedRouterConnectivity'
          label={intl.formatMessage({ id: 'dthConnectivityWithInternetRedRouter' })}
          disabled={!externalNetworks.includes('external_pi-net2inet_provider')}
        />
      </Grid>
    </Grid>
  );
};

export default NetworkConnectivity;
